import { axiosInstance } from "./apiConfig"

export const apiAvailabilityReservation = async ({ date, covers }) => {
    try {
        const response = await axiosInstance.get(`/reservation/availability?pageSize=30&covers=${covers}&date=${date}`);
        return response.data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}


// WEBPACK FOOTER //
// ./src/api/apiAvailabilityReservation.js